var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('page-title',{attrs:{"title":this.survey.name || 'New Survey',"action-loading":_vm.loading}}),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"md":24}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }